import { Component, OnInit, Input } from '@angular/core';
import { OhnLogicService } from '../../../services/ohn-logic.service';

@Component({
  selector: 'app-numeric-slider-element',
  templateUrl: './numeric-slider-element.component.html',
  styleUrls: ['./numeric-slider-element.component.scss'],
})
export class NumericSliderElementComponent implements OnInit {

  @Input() el: any;
	@Input() viewMode : string;

  validityRules : any[];
  rangeArray : number[]; 

  constructor() { }

  ngOnInit() {
    this.rangeArray = Array(Number(this.el.config.max)).fill(1).map((x,i) => i+1);
    this.el.value = this.el.value || 0;
    this.el.valid = true;
  }
}